module.exports = __webpack_public_path__ + "img/approved.1fed1fd3.svg";